import { GET } from "../APiHelper/API";

export const getBrokersAndCurrencies = (onSuccess, onError) => {
  GET("/api/v1/bets/brokers", onSuccess, onError);
};
